

; (function (window, document, $) {
    'use strict';
    
    var defaultOptions = {
        componentSelector: '[data-component="toc"]',
        componentListSelector: '[data-component="toc-list"]',
        containerSelector: '[data-toc]',
        headingsSelector: 'h2',
        itemClass: 'c-toc__item',
        itemActiveClass: 'is-active'
    };

    var ToC = {
        init: function (options) {
            this.options = $.extend({}, defaultOptions, options);

            this.$html = $('html');
            this.$component = $(this.options.componentSelector);
            this.$componentList = this.$component.find(this.options.componentListSelector);
            this.hasToC = ($(this.options.containerSelector).has(this.options.headingsSelector).length > 0);

            if (!this.hasToC) {
                this.$component.remove();
                return;
            }

            this.$componentList.toc({
                selectors: this.options.headingsSelector,
                container: this.options.containerSelector,
                prefix: 'section',
                listType: '<ul class="c-toc__list  o-block-list" />',
                itemClass: function () { return this.options.itemClass; }.bind(this),
                activeClass: this.options.itemActiveClass
            });

            this.initEvents();
        },
        initEvents: function () {
            this.$component.on('click', this.options.componentListSelector + ' a', function () {
                this.$html.removeClass('has-toc-opened');
            }.bind(this));
        }
    };

    $(function () {
        ToC.init();
    });
})(window, document, jQuery);